const RANKING = [
  { rank: 1, title: '极限追凶', type: '动作 / 犯罪', score: '9.2', hot: true, trend: 'up' },
  { rank: 2, title: '笑花开局', type: '喜剧 / 剧情', score: '8.9', hot: true, trend: 'up' },
  { rank: 3, title: '星际征途：新纪元', type: '科幻 / 冒险', score: '8.7', hot: false, trend: 'new' },
  { rank: 4, title: '暗夜追踪者', type: '悬疑 / 惊悚', score: '8.5', hot: true, trend: 'up' },
  { rank: 5, title: '武林风云录', type: '动作 / 武侠', score: '8.3', hot: false, trend: 'up' },
  { rank: 6, title: '欢乐一家人', type: '喜剧 / 家庭', score: '8.1', hot: false, trend: 'down' },
  { rank: 7, title: '深海危机', type: '动作 / 灾难', score: '7.9', hot: true, trend: 'new' },
];

const TREND_ICONS: Record<string, string> = {
  up: 'ri-arrow-up-line',
  down: 'ri-arrow-down-line',
  new: 'ri-sparkling-line',
};

const TREND_COLORS: Record<string, string> = {
  up: 'text-accent-500',
  down: 'text-secondary-500',
  new: 'text-primary-500',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热播榜单
          </h2>
          <p className="text-sm text-foreground-500 mt-2">本周最受欢迎的高清电影</p>
        </div>

        <div className="max-w-2xl mx-auto">
          {RANKING.map((item) => (
            <a
              key={item.rank}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="flex items-center gap-4 py-3.5 px-4 border-b border-background-200/40 last:border-0 hover:bg-background-100/80 transition-colors cursor-pointer group"
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-md font-heading text-sm font-bold flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500/20 text-primary-500'
                  : 'bg-background-200/60 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                  {item.hot && (
                    <span className="flex-shrink-0 px-1.5 py-0.5 text-[10px] font-medium bg-accent-500/15 text-accent-500 rounded">
                      HOT
                    </span>
                  )}
                </div>
                <p className="text-xs text-foreground-400 mt-0.5">{item.type}</p>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <i className={`${TREND_ICONS[item.trend]} ${TREND_COLORS[item.trend]} text-sm`} />
                <span className="text-sm font-heading font-bold text-primary-500">{item.score}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}